import { BaseModel } from "@/models/base.model"
import { ModelFactory } from "@/factories/model-factory"
import { WorkspaceAudienceGroup } from "@/workspace/models/workspace-audience-group.model"
import type { IWorkspaceNoteAudienceGroup } from "@/workspace/interfaces/api/workspace-note-audience-group.interface"

export class WorkspaceNoteAudienceGroup extends BaseModel implements IWorkspaceNoteAudienceGroup {
  public static className = "WorkspaceNoteAudienceGroup"
  public static verboseName = "werkruimtenotitiegroep"
  public static override managedResolveFields = ["audienceGroup"]

  declare id: string
  note: string
  audienceGroup: WorkspaceAudienceGroup

  constructor(link: IWorkspaceNoteAudienceGroup, managed = false) {
    super(link)
    this.note = link.note
    this.audienceGroup = ModelFactory.childModel(
      WorkspaceAudienceGroup,
      link.audienceGroup,
      managed
    )
  }
}
